import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, FreeMode } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


export function sectionNewsSwiper() {
    document.addEventListener("DOMContentLoaded", function () {
        new Swiper(".news-swiper", {
            modules: [Navigation, Pagination],
            loop: true,
            slidesPerView: 1,
            spaceBetween: 50,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                },
                1024: {
                    slidesPerView: 4,
                },
            },
        });
      });
}

export function marqueeSwiper() {
    document.addEventListener("DOMContentLoaded", function () {
        new Swiper(".marquee-swiper", {
            modules: [Navigation, Pagination, Autoplay, FreeMode],
            slidesPerView: "auto",
            spaceBetween: 30,
            freeMode: true,
            centeredSlides: true,
            loop: true,
            speed: 5000,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
            breakpoints: {
                380: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
                1024: {
                    slidesPerView: 4,
                },
                1440: {
                    slidesPerView: 5,
                },
            },
        });
    });
}
